export default "__VITE_ASSET__3a1462b9__"